import { render, staticRenderFns } from "./PdpDescription.vue?vue&type=template&id=0e5a10d4&"
import script from "./PdpDescription.vue?vue&type=script&lang=js&"
export * from "./PdpDescription.vue?vue&type=script&lang=js&"
import style0 from "./PdpDescription.vue?vue&type=style&index=0&id=0e5a10d4&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports